export default __webpack_public_path__ + "static/media/c1.1657e819.jpg";